import React, { useState } from 'react';
import { 
  Filter, 
  Search, 
  Download, 
  Upload, 
  X 
} from 'lucide-react';

/**
 * Componentă pentru filtrarea și acțiuni asupra utilizatorilor
 */
const UsersFilter = ({ 
  searchTerm, 
  setSearchTerm, 
  roleFilter, 
  setRoleFilter, 
  activeFilter, 
  setActiveFilter,
  resetFilters,
  handleSearch,
  onOpenExportModal,
  onOpenImportModal,
  onOpenFilterModal,
  isExporting = false,
}) => {
  // Statut pentru a determina dacă s-a modificat searchTerm-ul
  const [searchTermChanged, setSearchTermChanged] = useState(false);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setSearchTermChanged(true);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSearch();
    setSearchTermChanged(false);
  };

  return (
    <>
      {/* Bara de acțiuni */}
      <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-6">
        <form onSubmit={handleFormSubmit} className="md:flex-1">
          <div className="relative">
            <input
              type="text"
              placeholder="Caută după nume, email sau telefon..."
              className="glassmorphism w-full h-full pl-10 pr-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={handleInputChange}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
          </div>
        </form>
        
        <div className="flex space-x-2">
          <button 
            className="glassmorphism px-4 py-2 rounded-lg flex items-center text-gray-700 hover:bg-white/80 transition-colors"
            onClick={onOpenFilterModal}
          >
            <Filter className="h-5 w-5 mr-2" />
            <span>Filtrează</span>
          </button>
          
          <button 
            className={`glassmorphism px-4 py-2 rounded-lg flex items-center ${isExporting ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover:bg-white/80'} transition-colors`}
            onClick={onOpenExportModal}
            disabled={isExporting}
          >
            {isExporting ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-2 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Exportare...</span>
              </>
            ) : (
              <>
                <Download className="h-5 w-5 mr-2" />
                <span>Export Excel</span>
              </>
            )}
          </button>
          
          <button 
            className="glassmorphism px-4 py-2 rounded-lg flex items-center text-gray-700 hover:bg-white/80 transition-colors"
            onClick={onOpenImportModal}
          >
            <Upload className="h-5 w-5 mr-2" />
            <span>Import</span>
          </button>
        </div>
      </div>

      {/* Filtre active */}
      {(roleFilter || activeFilter) && (
        <div className="mb-4 flex flex-wrap items-center gap-2">
          <span className="text-sm text-gray-500 mr-2">Filtre active:</span>
          
          {roleFilter && (
            <div className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-sm flex items-center">
              Rol: {roleFilter === 'admin' ? 'Administrator' : 
                  roleFilter === 'partner' ? 'Partener' : 
                  roleFilter === 'client' ? 'Client' : roleFilter}
              <button 
                className="ml-2 text-blue-500 hover:text-blue-700"
                onClick={() => {
                  setRoleFilter('');
                  handleSearch();
                }}
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          )}
          
          {activeFilter && (
            <div className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-sm flex items-center">
              Status: {activeFilter === 'true' ? 'Activ' : 'Inactiv'}
              <button 
                className="ml-2 text-green-500 hover:text-green-700"
                onClick={() => {
                  setActiveFilter('');
                  handleSearch();
                }}
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          )}
          
          <button 
            className="text-gray-500 hover:text-gray-700 text-sm underline"
            onClick={() => {
              resetFilters();
              handleSearch();
            }}
          >
            Resetează toate
          </button>
        </div>
      )}
    </>
  );
};

export default UsersFilter;